import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {PmDashboardEntry} from "../../privacy-manager/dashboard/pm-dashboard-entry.model";

export class PrivacyManagerEndpoints {

	constructor(private http: HttpClient) {
	}

	deleteClientsData(correlationIds: string[]): Observable<HttpResponse<any>> {
		const url: string = `${environment.apiUrl}/privacy-manager/delete-client-data`;
		return this.http.delete(url, {observe: "response", headers: {"Content-Type": "application/json"}, body: {correlationIds: correlationIds}})
	}

	getEntries(): Observable<PmDashboardEntry[]> {
		return this.http.get<PmDashboardEntry[]>(`${environment.apiUrl}/privacy-manager/entries`)
	}
}
